import React, {useState} from 'react';
import { styles, mobileStyles } from './Style.js';
import { useIsMobile } from './useIsMobile.js';


function HeaderLink(props) {
    const neutralStyle = {
        backgroundColor: "#00ccff"
    };
    const activeStyle = {
        backgroundColor: "#94e8ff",
    };

    const [styling, setStyling] = useState(neutralStyle);

    const clickHandler = () => {
        if (props.href) {
            // `sameTab` is for pages that live on this site but outside the React
            // app — they have no header of their own, so leaving the tab intact
            // is what makes the browser's back button the way out of them.
            if (props.sameTab) {
                window.location.href = props.href;
            } else {
                window.open(props.href, "_blank", "noopener,noreferrer");
            }
        } else {
            props.handleClick(props);
        }
    }

    const buttonStyle = {
        ...styles.HeaderButton,
        border: "none",
        ...styling,
        cursor: "pointer",
        ...(props.isMobile ? mobileStyles.HeaderButton : { flex: 1, margin: 10 }),
    };

    const textStyle = props.isMobile
        ? {...styles.HeaderText, ...mobileStyles.HeaderText}
        : styles.HeaderText;

    return (
        <button style={buttonStyle} onMouseOut={() => setStyling(neutralStyle)} onMouseOver={() => setStyling(activeStyle)} onClick={clickHandler} >
            <p style={textStyle}>{props.text}</p>
        </button>
    );
}

export function Header(props) {
    const isMobile = useIsMobile();

    return (
        <div style={isMobile ? {...styles.Header, ...mobileStyles.Header} : styles.Header}>
            <HeaderLink isMobile={isMobile} text="About Me" page="about-me" handleClick={props.changePage} />
            {/* <HeaderLink text="Portfolio" page="portfolio" handleClick={props.changePage} /> */}
            {/* <HeaderLink text="Games" page="games" handleClick={props.changePage} /> */}
            <HeaderLink isMobile={isMobile} text="Tic-Tac-Toe AI" page="tic-tac-toe-ai" handleClick={props.changePage} />
            <HeaderLink isMobile={isMobile} text="Set Game" page="set-game" handleClick={props.changePage} />
            {/*
              A standalone page, not a React page: /contra/ is its own app,
              built separately and dropped into public/. It deliberately has no
              header — a caller needs every pixel of the floor, and the back
              button is a better way out than a nav bar that costs a strip of it.
            */}
            <HeaderLink isMobile={isMobile} text="Contra Caller" href="/contra/" sameTab />
            <HeaderLink isMobile={isMobile} text="Artypot" href="https://artypot.com" />
        </div>
    );
}
